/** Format an epoch-ms timestamp as a short locale date (e.g. 8/11/2025). Empty when absent. */
export const formatDate = (ms?: number): string =>
  ms === undefined ? '' : new Date(ms).toLocaleDateString();

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * True when an epoch-ms timestamp falls within the last 30 days. Used to flag
 * recently-added tracks with a "New" badge. False when absent.
 */
export const isRecentlyAdded = (ms?: number): boolean =>
  ms !== undefined && ms > Date.now() - THIRTY_DAYS_MS;
